export default __webpack_public_path__ + "static/logo-cdd5c7c84f442f4b12c25f69aa436bbb.webp";